import './polyfill';
import initialize from '@src/initialize';
import constants from '@src/constants';
import renderApp from '@src/render-app';
import fetchMock from '@src/services/fetch-mock';
import { applyMockScenarioFromSearch } from '@src/services/zt/mock/scenarios';

require('./tracker/track-page-load');
require('./tracker/track-page-leave');
/**
 * 禁止浏览器自动帮助恢复滚动位置
 * @type {string}
 */
window.history.scrollRestoration = 'manual';

(async () => {
  if (DEPLOY_ENV !== 'master' && constants.IS_MOCK_ON) {
    applyMockScenarioFromSearch();
    await fetchMock();
  }

  /**
   * 初始化
   */
  initialize();

  renderApp();
})();

/**
 * 热更新
 */
if (module.hot) {
  module.hot.accept();
}
